import { render, staticRenderFns } from "./index.vue?vue&type=template&id=180a9d34&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=180a9d34&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180a9d34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\word\\aiks-big-screen-v1-shanxi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180a9d34')) {
      api.createRecord('180a9d34', component.options)
    } else {
      api.reload('180a9d34', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=180a9d34&scoped=true", function () {
      api.rerender('180a9d34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CommonTable/index.vue"
export default component.exports